import { render, staticRenderFns } from "./CollectivesListAddNew.vue?vue&type=template&id=35aa57e6&"
import script from "./CollectivesListAddNew.vue?vue&type=script&lang=js&"
export * from "./CollectivesListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CollectivesListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports